/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner
 */
export interface GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner {
    /**
     * スカウト残数
     * @type {number}
     * @memberof GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner
     */
    scoutRemainNum: number;
    /**
     * スカウト有効期限(YYYY-MM-DD)
     * @type {string}
     * @memberof GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner
     */
    scoutRemainExpireAt: string;
}

/**
 * Check if a given object implements the GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner interface.
 */
export function instanceOfGetAccountStatuses200ResponseSystemStatusesAddedScoutsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "scoutRemainNum" in value;
    isInstance = isInstance && "scoutRemainExpireAt" in value;

    return isInstance;
}

export function GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerFromJSON(json: any): GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner {
    return GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerFromJSONTyped(json, false);
}

export function GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scoutRemainNum': json['scout_remain_num'],
        'scoutRemainExpireAt': json['scout_remain_expire_at'],
    };
}

export function GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerToJSON(value?: GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'scout_remain_num': value.scoutRemainNum,
        'scout_remain_expire_at': value.scoutRemainExpireAt,
    };
}

